import React from 'react'
import styles from '../AdminPanelPage.module.scss'

const GuardsPanel = ({
  guardsFilter,
  setGuardsFilter,
  filteredGuards,
  guardsPagination,
  loadGuardsPage,
  openCreateModal,
  startEdit,
  editingGuard,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
}) => {
  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>Окно: Охрана КПП</div>
        <div>
          <button className={styles.addButton} onClick={() => openCreateModal('guard')}>Добавить охранника</button>
        </div>
      </div>
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder="Поиск..." value={guardsFilter} onChange={(e) => setGuardsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadGuardsPage(1, guardsFilter) }} />

        </div>
        {filteredGuards && filteredGuards.length ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Сотрудник</th>
                <th>Телефон</th>
                <th>Дополнительный ном.тел</th>
                <th>Статус</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredGuards.map((g, index) => (
                <React.Fragment key={g.id}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{g.employee_name || g.employee_name || `#${g.id}`}</td>
                    <td>{g.employee_phone || '-'}</td>
                    <td>{g.phone || '-'}</td>
                    <td>{g.is_active ? 'Активен' : 'Неактивен'}</td>
                    <td>
                      <button className={styles.smallBtn} onClick={() => { startEdit('guard', g.id, { phone: g.phone, is_active: g.is_active }) }}>Изменить</button>
                    </td>
                  </tr>
                  {editingGuard === g.id && (
                    <tr>
                      <td colSpan={6}>
                        <div style={{ padding: 8 }}>
                          <label>Телефон</label>
                          <input value={(editPayloads[`guard__${g.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`guard__${g.id}`]: { ...p[`guard__${g.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>Активен</label>
                          <input type="checkbox" checked={(editPayloads[`guard__${g.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`guard__${g.id}`]: { ...p[`guard__${g.id}`], is_active: e.target.checked } }))} />
                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('guard', g.id)}>Сохранить</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('guard', g.id)}>Отмена</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <div>Список пуст</div>
        )}
        {(!guardsFilter && guardsPagination && guardsPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!guardsPagination.previous} onClick={() => loadGuardsPage((guardsPagination.page || 1) - 1)}>Пред.</button>
            <span>Стр. {guardsPagination.page || 1} — Всего: {guardsPagination.count}</span>
            <button disabled={!guardsPagination.next} onClick={() => loadGuardsPage((guardsPagination.page || 1) + 1)}>След.</button>
          </div>
        )}
      </div>
    </div>
  )
}

export default GuardsPanel
